import React, { Component, Fragment } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { confirmAlert } from 'react-confirm-alert';
import axios from 'components/AppRequest';
import {
  HOME_TYPE,
  WORK_TYPE,
} from 'components/common/constants/addressTypesConstants';
import { addressDataHelper } from 'components/common/helpers/addressDataHelper';
import { connect } from 'react-redux';
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';

class AddressItem extends Component {

  trans = (key, pref = "content.addressItem") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type,'content.notifications.addressItem');
  }

  onClickDelete = (event) => {
    event.preventDefault();
    const options = {
      title: this.trans('deleteTitle'),
      message: this.trans('deleteQuestion'),
      willUnmount: () => { },
      customUI: ({ title, message, onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <div className='react-confirm-header'>
              <FontAwesomeIcon
                icon={['far', 'frown']}
                size="2x"
              />
              <h1 dangerouslySetInnerHTML={{ __html: title }} />
            </div>

            <div className='react-confirm-desc'>
              <p>{message}</p>
            </div>

            <div className='react-confirm-alert-button-group'>
              <button
                onClick={() => { this.removeCard(); onClose(); }}
                className="button btn-remove">
                {this.trans('confirmButton')}
              </button>
              <button onClick={onClose} className="button btn-cancel">{this.trans('rejectButton')}</button>
            </div>

            <button onClick={onClose} title={this.trans('close', 'content.common')} className="react-confirm-close">
              <FontAwesomeIcon
                icon={['fas', 'times']}
                size="2x"
              />
            </button>
          </div>
        )
      }
    };
    confirmAlert(options);
  }

  removeCard() {
    var params = { id: this.props.id };
    axios.post('/pwa/customer/remove-address', params)
      .then(response => {
        this.props.createSuccessNotification({
          message: this.transNotify('success')
        })
        this.props.refreshList();
      })
      .catch(err => {
        this.props.createErrorNotification({
          title: this.transNotify('error'),
          message: this.transNotify('errorMessage')
        })
        console.log('err', err)
      });
  }

  getIconName() {
    switch (this.props.type) {
      case HOME_TYPE:
        return 'hotel';
      case WORK_TYPE:
        return 'briefcase';
      default:
        return 'star';
    }
  }

  render() {
    const { bus_stop_name, is_bus_stop, name, type } = this.props
    var itemName = is_bus_stop ? bus_stop_name : name;
    const { icon } = addressDataHelper(type)
    return (
      <li className="list-border__item">
        <FontAwesomeIcon
          icon={[`fas`, icon]}
          className="list-border__icon"
        />
        {itemName}
        <button
          className="button--icon"
          title={this.trans('deletePlaceTitle')}
          onClick={this.onClickDelete}
        >
          <FontAwesomeIcon
            icon={['fas', 'trash']}
            size="lg"
          />
        </button>
      </li>
    )
  }
}

export default connect(
  null,
  { createErrorNotification, createSuccessNotification }
)(AddressItem);
